import React, { forwardRef } from 'react'
import { TagProps as AntTagProps } from 'antd'
import { StyledTag } from './styled'

export type TagVariant =
  | 'default'
  | 'primary'
  | 'secondary'
  | 'accent'
  | 'success'
  | 'attention'
  | 'severe'
  | 'danger'
  | 'done'
  | 'created'
  | 'processed'
  | 'warning'
  | 'deleted'

export type TagSize = 'medium' | 'large'

export interface CustomTagProps extends Omit<AntTagProps, 'size'> {
  variant?: TagVariant
  size?: TagSize
  children: React.ReactNode
  isClicked?: boolean
}

export const Tag = forwardRef<HTMLSpanElement, CustomTagProps>(
  (
    {
      variant = 'default',
      size = 'large',
      children,
      className,
      isClicked = false,
      ...restProps
    },
    ref
  ) => {
    return (
      <StyledTag
        variant={variant}
        size={size}
        isClicked={isClicked}
        className={className}
        ref={ref}
        {...restProps}
      >
        {children}
      </StyledTag>
    )
  }
)

Tag.displayName = 'Tag'

export default Tag
